import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useSaveContract = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "addContract",
        command: "",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contractListState"],
      });
    },
  });
};
